import { Translatable } from '@icc/shared/helpers';

/** Typ montazu */
export class PleatedMosquitoScreenMontageType {
    id: number;
    @Translatable({ model: 'MontageTypes' })
    name: string;
    /** Kod do wydruków */
    printCode?: string;
    description: string;
    shortDescription: string;
    /** Sytuacja budowlana */
    situations?: 'elevation-guidance' | 'elevation-window-width' | 'in-recess' | 'in-recess-right' | 'for-development' | 'top-mounted' | 'other';
    situationsDescription?: string;
    integratedWithGuides?: boolean;
    methodOfInstallation?: 'internal' | 'external' | 'none' | 'internalAndExternal';
    /** Zawsze dostępny */
    alwaysAccessible: boolean;
    /** Zdjęcie 1 */
    photo1: string;
    /** Zdjęcie 2 */
    photo2: string;
    /** Przypisane typy produktów */
    shutterTypesIds?: number[];
}